import React, { useRef } from "react";
import { TriangleAlert } from "lucide-react";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function SendEHRConfirm({
  activeModal = false,
  ehrSendDate = null,
  onCancel = () => {},
  onConfirm = () => {},
}) {
  const dropdownRef = useRef(null);

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={onCancel}>
        <Drawer.Trigger></Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">Resend EHR</Drawer.Title>
            <Drawer.Description className="sr-only">Resend EHR data</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <div className="docpro_deleteboxbox modal_height_100" style={{ textAlign: 'start' }}>
                  <div>
                    <div className="docpro_iconbox_icon docpro_badge_orange">
                      <TriangleAlert width={50} height={50} />
                    </div>
                    <Spacing lg="20" sm="20" />
                    <div className="docpro_iconbox_right flex items-center" style={{ justifyContent: 'center' }}>
                      <div>
                        <h3 className="docpro_fs_20 mb-2">If you resend:</h3>
                        <ul className="docpro_mb_0">
                          {ehrSendDate && <li>Existing ICDs from {ehrSendDate} will remain</li> }
                          <li>New ICDs will be added</li>
                          <li>All ICDs will post to the patient’s latest encounter</li>
                          <li>Please review in the EHR after posting</li>
                        </ul>
                        <Spacing lg="32" sm="32" />
                      </div>
                    </div>
                  </div>
                  <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                    <button
                      type="button"
                      className="docpro_bordered_btn docpro_fw_600 size_lg"
                      onClick={() => {
                        onCancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                      onClick={() => {
                        onConfirm();
                        onCancel();
                      }}
                    >
                      Send to EHR
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
